//@ts-expect-error not typed yet
import Workflow from 'EmailData/models/Workflow';
import { getWorkflowEditUrlForSourceApp } from 'EmailComponents/utils/automation';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { WarningIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Link } from 'foundations-components/transitional/components/Link';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function WorkflowAlert({
  emailsWithWFInfo,
  action = 'unpublish'
}) {
  const isBulk = useMemo(() => {
    return emailsWithWFInfo.length > 1;
  }, [emailsWithWFInfo.length]);
  const workflowCount = useMemo(() => {
    return emailsWithWFInfo.reduce((acc, emailWithFlows) => {
      return acc + emailWithFlows.flows.length;
    }, 0);
  }, [emailsWithWFInfo]);
  const shouldRenderList = useMemo(() => {
    return !isBulk && workflowCount > 1;
  }, [isBulk, workflowCount]);
  if (workflowCount === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(Alert, {
    marginBlockStart: "400",
    "data-test-id": "workflow-alert",
    type: "warning",
    children: isBulk ? /*#__PURE__*/_jsx(AlertBody, {
      shouldRenderList: shouldRenderList,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "email-workflow-alert.bulkTitle",
        options: {
          count: workflowCount
        }
      }),
      subtitle: action === 'delete' ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "email-workflow-alert.deleteBulkBody",
        options: {
          count: workflowCount
        }
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "email-workflow-alert.bulkBody",
        options: {
          count: workflowCount
        }
      }),
      emailsWithWFInfo: emailsWithWFInfo
    }) : /*#__PURE__*/_jsx(AlertBody, {
      shouldRenderList: shouldRenderList,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "email-workflow-alert.title",
        options: {
          count: workflowCount
        }
      }),
      subtitle: action === 'delete' ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "email-workflow-alert.deleteBody_jsx",
        options: {
          count: workflowCount,
          href: getWorkflowEditUrlForSourceApp(Workflow.from(emailsWithWFInfo[0].flows[0])),
          name: emailsWithWFInfo[0].flows[0].name
        },
        elements: {
          Link
        }
      }) : /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "email-workflow-alert.body_jsx",
        options: {
          count: workflowCount,
          href: getWorkflowEditUrlForSourceApp(Workflow.from(emailsWithWFInfo[0].flows[0])),
          name: emailsWithWFInfo[0].flows[0].name
        },
        elements: {
          Link
        }
      }),
      emailsWithWFInfo: emailsWithWFInfo
    })
  });
}
function AlertBody({
  shouldRenderList,
  title,
  subtitle,
  emailsWithWFInfo
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "row",
    children: [/*#__PURE__*/_jsx(View, {
      children: /*#__PURE__*/_jsx(WarningIcon, {
        color: "do-not-use-marigold-dark",
        size: "300"
      })
    }), /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      marginInlineStart: "200",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h7",
        marginBlockEnd: "200",
        children: title
      }), subtitle, shouldRenderList && /*#__PURE__*/_jsx(List, {
        styled: true,
        marginBlockStart: "200",
        paddingInlineStart: "300",
        children: emailsWithWFInfo[0].flows.map(flow => {
          return /*#__PURE__*/_jsx(ListItem, {
            children: /*#__PURE__*/_jsx(Link, {
              external: true,
              href: getWorkflowEditUrlForSourceApp(Workflow.from(flow)),
              children: flow.name
            })
          }, flow.id);
        })
      })]
    })]
  });
}